import { Fragment, useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import axios from 'axios';
import { apiEndpoint } from './constants/api';
import Modal from './components/Modal';
import { ProjectJobTable } from './components/ProjectJobTable';
import { avatar } from './constants/Avatar';
import Header from './components/Header';
import Aside from './components/Aside';
import ProdzFooter from './components/Footer';
import Nav from './components/Nav';

const connector = connect((state, ownProps) => ({ 
 ...state.user,
 employer: {...state.user.currentEmployer}
}), {});
function Project({ user, employer }) {

  const [projectData, setProjectData] = useState({});
  const [jobData, setJobData] = useState([]);
  const [isOpened, setIsOpened] = useState(false);
  const { id } = useParams();

  const loadProjectData = async (q) => {
    if(employer.value && id){
      const { data } = await axios.get(apiEndpoint(`/admin/employer/project/${employer.value}/${id}`));
      setProjectData(data[0]);
      const { data: jobs } = await axios.get(apiEndpoint(`/admin/employer/project/jobs/${employer.value}/${id}`));
      setJobData(jobs);
    }
  };

  const closeModal = async () => {
    loadProjectData();
    setIsOpened(false);
  };

  const openModal = async () => {
    loadProjectData();
    setIsOpened(true);
  };

  useEffect(() => {
    loadProjectData();
  }, [employer]);

  return (
    <>
    <Helmet>
      <title>{ projectData.name || '' } | Project | Productions.com</title>
    </Helmet>
      <div className="min-h-full">
        <Nav />
        <>
          <Header publicId={employer.logo} />
          <Aside />
          <main className="p-4 sm:ml-64">
            <div className="mx-auto sm:px-6 lg:px-8">
              {/* Replace with your content */}
              <div>
                <div className="w-full mb-2 bg-white border border-gray-200 rounded-lg shadow sm:p-8 dark:bg-gray-800 dark:border-gray-700">
                  <div className="flex gap-4">
                    <div>
                      <div>
                        <h1 className="text-4xl text-gray-800">
                          {projectData.name}
                        </h1>
                      </div>
                      <div className="text-lg">{projectData.description}</div>
                    </div>
                    <div className="grow flex-col">
                      <div className="flex justify-end">
                        <button
                          type="button"
                          className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2"
                        >
                          Edit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="py-4">
                    {jobData && <ProjectJobTable jobData={jobData} />}
                  </div>
              </div>
              {/* /End replace */}
            </div>
            <Modal
              title="Edit Project"
              isOpened={isOpened}
              modalData={projectData}
              onClose={closeModal}
            >
              <form className="my-10">
                <div className="text-lg text-left"></div>
                <p>Modify a role for a user</p>

                <div className="my-2">
                  <button
                    type="button"
                    className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2"
                  >
                    Update Project
                  </button>
                  <button
                    type="button"
                    className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </Modal>
            <ProdzFooter />
          </main>
        </>
      </div>
    </>
  );
}

export default connector(Project);
